<template>
  <div class="trustpilot d-flex flex-column align-items-center justify-content-center gap-1 gap-md-2 group">
    <img
      :src="trustpilotLogo"
      alt="trustpilot logo"
      class="logo-img"
    />

    <div class="w-100 d-flex align-items-center ps-1 gap-1 overflow-visible">
      <p class="small text-white-90 mb-0">Read reviews</p>
      <i class="bi bi-arrow-up-right text-white small ms-1 arrow-icon"></i>
    </div>
  </div>
</template>

<script>
import trustpilotLogo from "../../public/assets/client-image/trustpilot.png";

export default {
  name: "TrustPilot",
  data() {
    return {
      trustpilotLogo,
    };
  },
};
</script>

<style scoped>
.trustpilot {
  transition: all 0.3s ease-in-out;
}

.logo-img {
  width: 100px;
  height: 20px;
}

@media (min-width: 992px) {
  .logo-img {
    width: 137px;
    height: 38px;
  }
}

.arrow-icon {
  transform: translateX(-10px);
  opacity: 0;
  transition: all 0.3s ease;
}

.trustpilot:hover .arrow-icon {
  transform: translateX(0);
  opacity: 1;
}
</style>
